import React, { useState } from 'react'
import AccelerateGoToMarket80pxSvg from './../../../assets/images/icons/svg/AccelerateGoToMarket80pxSvg';
import Techagnostic80pxSvg from './../../../assets/images/icons/svg/Techagnostic80pxSvg';
import SecureAndRelible80pxSvg from './../../../assets/images/icons/svg/SecureAndRelible80pxSvg';
import FlexibleAndScalable80pxSvg from './../../../assets/images/icons/svg/FlexibleAndScalable80pxSvg';
import DeviceManagement48pxSvg from './../../../assets/images/icons/svg/DeviceManagement48pxSvg';
import DeviceMessageHistory48pxSvg from './../../../assets/images/icons/svg/DeviceMessageHistory48pxSvg';
import MrSecure48pxSvg from './../../../assets/images/icons/svg/MrSecure48pxSvg';
import MrConnectFOTA48pxSvg from './../../../assets/images/icons/svg/MrConnectFOTA48pxSvg';
import ParsingOfIOT48pxSvg from './../../../assets/images/icons/svg/ParsingOfIOT48pxSvg';
import DeviceNetworkTelemetry48pxSvg from './../../../assets/images/icons/svg/DeviceNetworkTelemetry48pxSvg';
import RetryPolicies48pxSvg from './../../../assets/images/icons/svg/RetryPolicies48pxSvg';
import MrConnectLocate48pxSvg from './../../../assets/images/icons/svg/MrConnectLocate48pxSvg';
import ApiAccessResful48pxSvg from './../../../assets/images/icons/svg/ApiAccessResful48pxSvg';
import DeviceConfiguration48pxSvg from './../../../assets/images/icons/svg/DeviceConfiguration48pxSvg';
import DeviceStatusManagement48pxSvg from './../../../assets/images/icons/svg/DeviceStatusManagement48pxSvg';
import DynamicAlerts48pxSvg from './../../../assets/images/icons/svg/DynamicAlerts48pxSvg';
import accelerate_go_to_market from "../../../assets/images/content/mr-connect-data-platform/accelerate-go-to-market.png"
import accelerate_go_to_market_phone from "../../../assets/images/content/mr-connect-data-platform/accelerate-go-to-market-phone.png"
import sgd from "../../../assets/images/logo/SGD.png"
import iso_27001 from "../../../assets/images/logo/iso-27001.png"
import { StyledLinkBlue } from '../../../components/StyledLink';
import { useTranslation } from 'react-i18next';

const KeyBenefitTab = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {t} = useTranslation()
    const AccelerateGoToMarketData = [
        {
            icon: <DeviceManagement48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.device-management'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.monitor-and-configure-devices')
        },
        {
            icon: <DeviceMessageHistory48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.divice-message-history'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.store-device-message-for-up-to')
        },
        {
            icon: <MrSecure48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.mrsecure'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.a-proprietary-encryption-protocol-that')
        },
        {
            icon: <MrConnectFOTA48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.mrconnect-fota'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.simple-effecient-and-secured')
        },
        {
            icon: <ParsingOfIOT48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.parsing-of-iot-device-data'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.decode-message-based-on-device')
        },
        {
            icon: <DeviceNetworkTelemetry48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.device-network-telemetry'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.gain-insights-and-visibility')
        },
        {
            icon: <RetryPolicies48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.retry-policies-for-connectors'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.avoid-data-loss-due-to-maintenance')
        },
        {
            icon: <MrConnectLocate48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.mrconnect-locate'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.reliable-muti-source-wifi')
        },
        {
            icon: <ApiAccessResful48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.api-access-restful-graphql'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.transform-enterprise-system-into-an-iot')
        },
        {
            icon: <DeviceConfiguration48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.device-configuration'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.configure-a-single-device')
        },
        {
            icon: <DeviceStatusManagement48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.device-status-management'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.motitor-and-manage-the-status')
        },
        {
            icon: <DynamicAlerts48pxSvg />,
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.dynamic-alerts'),
            content: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.notification-and-monitoring-capabilities')
        },
    ]

    const keyBenefitData = [
        {
            title: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.title'),
            icon: <AccelerateGoToMarket80pxSvg />,
            subTitle: t('mrconnect-iot-cloud-platform.accelerate-go-to-market.description'),
            content:
                <div className='flex flex-col gap-7 animate-bottomFadeIn lg:animate-rightFadeIn'>
                    <p className='font-semibold text-lg text-primary'><span className='text-blue-primary uppercase '>{t('mrconnect-iot-cloud-platform.accelerate-go-to-market.fast')}</span> {t('mrconnect-iot-cloud-platform.accelerate-go-to-market.managing-a-large-fleet')}</p>
                    <div className='flex flex-col gap-3 '>
                        <p>{t('mrconnect-iot-cloud-platform.accelerate-go-to-market.mrconnect-supports-mutiple-payloads')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.accelerate-go-to-market.keeping-track-of-each-devices-firmware')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.accelerate-go-to-market.mrconnect-allows-users-with-assigned-permission')}</p>
                    </div>
                    <div className='grid grid-cols-6 gap-x-10 gap-y-10'>
                        {AccelerateGoToMarketData.map((value, index) => (
                            <div className='col-span-6 md:col-span-3 xl:col-span-2 pr-10' key={index}>
                                <div className='flex flex-col gap-2'>
                                    {value.icon}
                                    <p className='text-lg font-bold text-primary'>{value.title}</p>
                                    <p className='text-base'>{value.content}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='grid grid-cols-12 items-center md:gap-x-10 gap-y-10'>
                        <div className='col-span-12 xl:col-span-8 flex justify-center'>
                            <img src={accelerate_go_to_market} alt="accelerate" className='img-responsive' />
                        </div>
                        <div className='col-span-12 xl:col-span-4 flex justify-center'>
                            <img src={accelerate_go_to_market_phone} alt="accelerate_phone" className='img-responsive max-h-[395px]' />
                        </div>
                    </div>
                </div>
        },
        {
            title: t('mrconnect-iot-cloud-platform.tech-agnostic.title'),
            icon: <Techagnostic80pxSvg />,
            subTitle: t('mrconnect-iot-cloud-platform.tech-agnostic.description'),
            content:
                <div className='flex flex-col gap-7 animate-bottomFadeIn lg:animate-rightFadeIn'>
                    <p className='font-semibold text-lg text-primary'><span className='text-blue-primary uppercase '>{t('mrconnect-iot-cloud-platform.tech-agnostic.tech-agnostic')}</span> {t('mrconnect-iot-cloud-platform.tech-agnostic.a-solution-for-any-device')}</p>
                    <div className='flex flex-col gap-3'>
                        <p>{t('mrconnect-iot-cloud-platform.tech-agnostic.mrconnect-allow-a-diverse-fleet')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.tech-agnostic.no-single-connectivity-option-can-fit')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.tech-agnostic.mrconnect-is-also-platform-agnostic')}</p>
                    </div>
                </div>
        },
        {
            title: t('mrconnect-iot-cloud-platform.secure-and-reliable.title'),
            icon: <SecureAndRelible80pxSvg />,
            subTitle: t('mrconnect-iot-cloud-platform.secure-and-reliable.description'),
            content:
                <div className='flex flex-col gap-7 animate-bottomFadeIn lg:animate-rightFadeIn'>
                    <p className='font-semibold text-lg text-primary'><span className='text-blue-primary uppercase '>{t('mrconnect-iot-cloud-platform.secure-and-reliable.secure')}</span> {t('mrconnect-iot-cloud-platform.secure-and-reliable.a-robust-and-reliable-solution')}</p>
                    <div className='flex flex-col gap-3'>
                        <p>{t('mrconnect-iot-cloud-platform.secure-and-reliable.mrconnect-has-perfect-uptime')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.secure-and-reliable.with-its-customiable-retry-policy')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.secure-and-reliable.built-on-a-role-based-access-control-approach')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.secure-and-reliable.users-can-also-monitor-the-devices')}</p>
                    </div>
                    <div className='grid grid-cols-2 gap-x-12'>
                        <div className='col-span-1 flex flex-col gap-5 items-center'>
                            <div className='h-[110px] flex items-center'>
                                <img src={sgd} alt="sgd" className='max-w-28' />
                            </div>
                            <p className='text-center'><StyledLinkBlue>{t('mrconnect-iot-cloud-platform.secure-and-reliable.mrconnect-is-sgd-accredited')}</StyledLinkBlue> {t('mrconnect-iot-cloud-platform.secure-and-reliable.the-company-has-udergone-vigorous-financial')} <StyledLinkBlue>{t('mrconnect-iot-cloud-platform.secure-and-reliable.imda')}</StyledLinkBlue> {t('mrconnect-iot-cloud-platform.secure-and-reliable.to-ascertain-our-ability-to-deliver')}</p>
                        </div>
                        <div className='col-span-1 flex flex-col gap-5 items-center'>
                            <div className='h-[110px] flex items-center'>
                                <img src={iso_27001} alt="iso_27001" className='max-w-28' />
                            </div>
                            <p className='text-center'><b>{t('mrconnect-iot-cloud-platform.secure-and-reliable.mrconnect')}</b> {t('mrconnect-iot-cloud-platform.secure-and-reliable.has-achieved-iso-iec')} <b>{t('mrconnect-iot-cloud-platform.secure-and-reliable.information-security-management-system')}</b></p>
                        </div>
                    </div>
                </div>
        },
        {
            title: t('mrconnect-iot-cloud-platform.flexible-and-scalable.title'),
            icon: <FlexibleAndScalable80pxSvg />,
            subTitle: t('mrconnect-iot-cloud-platform.flexible-and-scalable.description'),
            content:
                <div className='flex flex-col gap-7 animate-bottomFadeIn lg:animate-rightFadeIn'>
                    <p className='font-semibold text-lg text-primary'><span className='text-blue-primary uppercase '>{t('mrconnect-iot-cloud-platform.flexible-and-scalable.scalable')}</span> {t('mrconnect-iot-cloud-platform.flexible-and-scalable.a-ready-to-scale-solution')}</p>
                    <div className='flex flex-col gap-3'>
                        <p>{t('mrconnect-iot-cloud-platform.flexible-and-scalable.mrconnect-is-a-serverless-solution')}</p>
                        <p>{t('mrconnect-iot-cloud-platform.flexible-and-scalable.mrconnect-can-absorb-a-burst-of-millions')}</p>
                    </div>

                </div>
        },
    ]

    return (
        <div className='container'>
            <p className='text-3xl md:text-40px font-semibold pb-5 lg:pb-10 text-primary'>{t('mrconnect-iot-cloud-platform.key-benefits')}</p>
            <div className='grid grid-cols-11 gap-x-5 gap-y-10'>
                <div className='col-span-11 lg:col-span-3 lg:border-r'>
                    {keyBenefitData.map((value, index) => (
                        <div className='flex flex-col first:pt-0 pt-4' key={index}>
                            {activeIndex === index && <div className='pb-4'>
                                {value.icon}
                            </div>}
                            <p className={`text-lg font-bold cursor-pointer hover:text-blue-primary ${activeIndex === index ? "text-blue-primary" : "text-primary"}`} onClick={() => setActiveIndex(index)}>{value.title}</p>
                            {activeIndex === index && <p className="pr-5 pb-5 pt-4">{value.subTitle}</p>}
                            {activeIndex === index && <div className='h-[2px] bg-[#006EFF] animate-leftToRight'/>}
                        </div>
                    ))}
                </div>
                <div className='col-span-11 lg:col-span-8'>
                    {keyBenefitData.map((value, index) => (
                        <div key={index}>
                            {activeIndex === index && value.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default KeyBenefitTab